/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.14.1
 * @since 1.0.1
 */

import styled from 'styled-components';

import { ILabelColor, LabelColor } from '../../../../../Table/constants/labelColor';

export const LabelSelectListStyled = styled.div.attrs({
    className: 'multiselect-item__label multiselect-item__label-mark',
})`
    display: flex;
    width: 100%;
`;

export const LabelCellStyled = styled.div<{ color: ILabelColor }>`
    padding-left: 12px;
    position: relative;

    &:before {
        position: absolute;
        top: 1px;
        left: 2px;
        transform: translate(0, 50%);
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        ${({ color }) => color ? `background-color:${LabelColor[color]};` : ''}
    }
`;
